import { useTranslation } from '@eti/providers';
import { Button, Inline, Text, textVariants, vars } from '@etg/wings';
import { Icon } from '@eti/components';
import { css } from '@eti/styles';
import type { Dispatch, SetStateAction } from 'react';

const buttonTagStyles = css`
  background-color: ${vars.colors.promotional.foreground};
  border: none;
  border-radius: 8px;
  color: ${vars.colors.promotional.background};
  padding: 4px 8px;

  :hover {
    background-color: ${vars.colors.promotional.foreground};
    color: ${vars.colors.promotional.background};
  }
`;

interface SelfTransferTagButtonProps {
  setIsSelfTransferModalOpen: Dispatch<SetStateAction<boolean>>;
}

const SelfTransferTagButton = ({ setIsSelfTransferModalOpen }: SelfTransferTagButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      className={buttonTagStyles}
      data-testid="self-transfer-trip-tag-button"
      onClick={setIsSelfTransferModalOpen ? () => setIsSelfTransferModalOpen(true) : undefined}
    >
      <Inline spacing={4}>
        <Icon color={vars.colors.promotional.background} id="self-transfer" size="20px" />
        <Text variant={textVariants._14_BOLD}>
          {t('Result.Page.SelfTransferDeals.Button.Text')}
        </Text>
      </Inline>
    </Button>
  );
};

export default SelfTransferTagButton;
